import React, { useEffect } from "react";
import { Col, Container, Row } from 'reactstrap';
import { reduxForm } from 'redux-form';
import Settlement from './Components/Settlement';
;


const SettlementSupport = ({ history, location }) => {

    useEffect(() => {

    }, []);

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">Soportes de Radicación</h3>
                </Col>
            </Row>
            <Settlement />
        </Container>
    );
}
export default reduxForm({
    form: 'rips_form',
})(SettlementSupport);